// ------------------ brand (static)
/* eslint-disable-next-line no-unused-vars */
const BRAND = (() => {
	// private var(s)

	// private method(s)
	const _constructor = () => {
		// console.log('Brand is running');
		const lang = document
			.getElementsByTagName('html')[0]
			.getAttribute('lang');
		if (lang) {
			I18n?.initDictionary('glo-kr', lang); // setup the i18n dictionary
		}
	};

	// Bind Events
	const _bindEvents = () => {
		// console.log('Bind Events Here');
	};

	_constructor();

	// output/public
	return {
		bindEvents: _bindEvents,
	};
})();
